<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('fileformat.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="fileformat.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('fileformat.form.fields.classe.label')"
            label-for="input-classe"
            :description="$t('fileformat.form.fields.classe.description')"
        >
          <b-form-input id="input-classe" v-model="fileformat.class" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('fileformat.form.fields.extensao.label')"
            label-for="input-classe"
            :description="$t('fileformat.form.fields.extensao.description')"
        >
          <b-form-input id="input-extensao" v-model="fileformat.extension" type="text"/>
        </b-form-group>
        <b-form-group
            label-for="input-status"
            :label="$t('fileformat.form.fields.has_cloud_function.label')"
            :description="$t('fileformat.form.fields.has_cloud_function.description')"
        >
          <b-form-checkbox id="input-has_cloud_function" v-model="hasCloudFunction" size="lg" switch/>
          <b-form-group
              v-if="hasCloudFunction"
              label-for="input-cloud_function"
              :label="$t('fileformat.form.fields.cloud_function.label')"
              :description="$t('fileformat.form.fields.cloud_function.description')"
          >
            <b-overlay :show="store_cloudFunctions_loading">
            <SelectComponent
                  id="input-cloud_function"
                  :model="fileformat.cloud_function"
                  :options="store_cloudFunctions | idNameToValueLabel"
                  @search="evt => {autocomplete('functions', evt)}"
                  @input="evt => setFileFormat('cloud_function', evt)"
              />
            </b-overlay>

          </b-form-group>
        </b-form-group>
        <b-form-group
            :label="$t('fileformat.form.fields.status.label')"
            label-for="input-status"
            :description="$t('fileformat.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="fileformat.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('fileformat.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import FileformatRepository from '@/repositories/vns/FileformatRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient,
    SelectComponent
  },
  data() {
    return {
      fileformat_id: null,
      hasCloudFunction: false
    }
  },
  computed: {
    ...mapGetters({
      store_cloudFunctions: 'functions/all',
      store_cloudFunctions_loading: 'functions/isLoading',
      fileformat: 'fileformat/current',
      isLoading: 'fileformat/isLoading'
    }),
    pageTitle() {
      if (this.fileformat_id) return this.$t('fileformat.form.titulo_pagina.editar')
      return this.$t('fileformat.form.titulo_pagina.criar')
    },
    cloudFunctions() {
      if (this.store_cloudFunctions && Array.isArray(this.store_cloudFunctions)) {
        return this.store_cloudFunctions.map((ent) => {
          return {
            label: ent.name,
            value: ent.id
          }
        })
      }
      return [];
    }
  },
  methods: {
    ...mapActions([
      'fileformat/listOne',
      'functions/search'
    ]),
    setFileFormat(key, value) {
      this.$store.commit('fileformat/setCurrent', {...this.fileformat, [key]: value})
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        await this.update()
      } else {
        this.create()
      }
    },
    create() {
      if (!this.hasCloudFunction){
        this.setFileFormat('integration_cloud_function_settings', null)
        this.setFileFormat('cloud_function', null)
      }

      if (this.hasCloudFunction && typeof(this.fileformat.cloud_function) == 'object') {
        this.fileformat.integration_cloud_function_settings = (this.fileformat.cloud_function.value) ? this.fileformat.cloud_function.value : this.fileformat.integration_cloud_function_settings ;
      }

      FileformatRepository.post(this.fileformat).then(response => {
        this.$snotify.success(this.$t('fileformat.form.create.success'))
        this.$router.push({name: 'vns.fileformat'})
      }).catch(error => {
        this.$snotify.error(this.$t('fileformat.form.create.error'))
        if (error.response.status === 422) {
          FileformatRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async update() {
      if (!this.hasCloudFunction){
        this.setFileFormat('integration_cloud_function_settings', null)
        this.setFileFormat('cloud_function', null)
      }
      
      if (this.hasCloudFunction) {
        this.fileformat.integration_cloud_function_settings = (this.fileformat.cloud_function != null) ? this.fileformat.cloud_function.value : this.fileformat.cloud_function ;
      }

      FileformatRepository.put(this.fileformat_id, this.fileformat).then(response => {
        this.$snotify.success(this.$t('fileformat.form.update.success'))
        this.$router.push({name: 'vns.fileformat'})
      }).catch(error => {
        this.$snotify.error(this.$t('fileformat.form.update.error'))
        if (error.response.status === 422) {
          FileformatRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    }
  },
  async mounted() {
    await this['functions/search']()
    this.$store.commit('fileformat/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.fileformat_id = this.$route.params.id
      await this['fileformat/listOne'](this.$route.params.id)
      if (this.fileformat.integration_cloud_function_settings) {
        this.hasCloudFunction = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
